import { Component, OnInit } from '@angular/core';
import { AppService } from '../app-service/app-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'aqualia-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css']
})
export class BreadCrumbComponent implements OnInit {

  constructor(public navbarService: AppService, public router : Router) { }

  ngOnInit() {
  }

}
